(function ($) {

    var $window = $(window);
    var $layer;
    var $container;
    var $userList;
    var $userCount;
    var $msgBox;
    var $moreListSpinner;
    var _magazineNo;
    var _userList;
    var _userCount;
    var _moreList;
    var _isLoading;

    var _init = function (magazineNo, defaultCount) {
        _magazineNo = magazineNo;
        _userCount = defaultCount || 0;
        _userList = [];
        _moreList = true;

        $container = $(B.Util.getTemplate('popup-user-list.hbs', {
            title: '구독자',
            showCount: true,
            count: _userCount
        }));
        $userList = $container.find('.user_list');
        $userCount = $container.find('.user_count');
        $moreListSpinner = $container.find('.spinner');

        $layer.append($container);

        $window.on('keydown', onKeydown);
        $container.on('click', onClick);
        $layer.on('scroll', onScroll);
    };

    var _show = function (magazineNo, followerCount) {
        $layer = B.Util.layer.showLayerBase();

        if (!$container) {
            _init(magazineNo, followerCount);
            onScroll();
        }

        $container.show();
    };

    var _hide = function () {
        B.Util.layer.hideLayerBase();
        $container.hide();
    };

    var _loadList = function () {
        if (_isLoading || !_moreList) {
            return;
        }

        _isLoading = true;


        var lastSubscribeNo = 0;

        if (_userList && _userList.length > 0) {
            lastSubscribeNo = _userList[_userList.length - 1].subscribeNo;
        }

        B.Util.ajax({
            url: B.Config.apiUrl + '/v2/subscription/magazine/' + _magazineNo + '/followers',
            method: 'GET',
            data: {
                subscribeNo: lastSubscribeNo
            },
            success: function (data) {
                _setUserCount(data.data.totalCount);
                _appendList(data.data.list);
                _setMoreList(data.data.moreList);
                _isLoading = false;
                onScroll();
            },
            error: function () {
                _isLoading = false;
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _setUserCount = function (totalCount) {
        _userCount = totalCount;
        $userCount.html(B.Util.numberFormat(_userCount));

        if (_userCount == 0) {
            $userList.hide();
            _showMessage('구독중인 작가가 없습니다.');
        } else {
            $userList.show();
        }
    };

    var _appendList = function (list) {
        for (var i = 0; i < list.length; i++) {
            _userList.push(list[i]);
            $userList.append(_makeUserView(list[i]));
        }
    };

    var _updateUserView = function (user) {
        var view = _makeUserView(user);
        $userList.find('li[data-userid=' + user.userId + ']').html(view.html());
    };

    var _makeUserView = function (user) {
        return $(B.Util.getTemplate('popup-magazine-author-item.hbs', {
            author: user,
            userId: B.User.userId
        }));
    };

    var _findUserByUserId = function (userId, callback) {
        var i;
        for (i = 0; i < _userList.length; i++) {
            if (_userList[i].userId == userId) {
                callback(i, _userList[i]);
                return;
            }
        }
    };

    var _setMoreList = function (moreList) {
        _moreList = moreList;

        if (_moreList) {
            $moreListSpinner.show();
        } else {
            $moreListSpinner.hide();
        }
    };

    var _followUser = function (userId) {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/subscription/user/follow',
            method: 'POST',
            data: {
                writerUserId: userId
            },
            success: function (data) {
                _findUserByUserId(userId, function (index, user) {
                    user.myWriter = true;
                    _updateUserView(user);
                });
            },
            error: function () {
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _unfollowUser = function (userId) {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/subscription/user/unfollow/@@' + userId,
            method: 'DELETE',
            success: function (data) {
                _findUserByUserId(userId, function (index, user) {
                    user.myWriter = false;
                    _updateUserView(user);
                });
            },
            error: function () {
                _showMessage('오류가 발생했습니다.');
            }
        });
    };

    var _showMessage = function (message) {
        if (!$msgBox) {
            $msgBox = $("<div class='message'></div>");
            $container.append($msgBox);
        }

        if (message) {
            $msgBox.html(B.Util.getTemplate('alert.hbs', {
                alertWrapTitle: message
            }));
            $msgBox.show();
            $userList.hide();
            $moreListSpinner.hide();
        } else {
            $msgBox.hide();
        }
    };

    var onClick = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        var btn = _getActionButton(this, e.target);
        var action = btn.data('action');
        var userId = btn.data('userid');

        if (action != null) {
            e.preventDefault();
        }

        if (action == 'close') {
            _hide();
        } else if (action == 'follow') {
            _followUser(userId);
        } else if (action == 'unfollow') {
            _unfollowUser(userId);
        }
    };

    var onScroll = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        _adjustHeader();

        if (!_moreList) {
            return;
        }

        var top = $moreListSpinner.offset().top - $layer.offset().top;
        var appearTop = $layer.height();

        if (appearTop > top) {
            _loadList();
        }
    };

    var _adjustHeader = function () {
        var top = $layer.scrollTop();
        var fixedClass = 'fixed';

        if (top > 0) {
            $container.addClass(fixedClass);
        } else {
            $container.removeClass(fixedClass);
        }
    };

    var onKeydown = function (e) {
        if (!$container.is(':visible')) {
            return;
        }

        if (e.keyCode == 27) {
            _hide();
            e.preventDefault();
        }
    };

    var _getActionButton = function (container, target) {
        var btn = $(target);
        while (!btn.is(container) && !btn.data('action')) {
            btn = btn.parent();
        }

        return btn;
    };

    B.Magazine.Follower = {
        show: function (magazineNo, followerCount) {
            _show(magazineNo, followerCount);
        },
        hide: function () {
            _hide();
        }
    };

})(jQuery);
